import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { catchError, defer, finalize, map, of } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FullPageMaskService, SpinnerModule } from 'common';
import { CommonModule } from '@angular/common';
import { SenderIdService } from '../../../services/sender-id-api.service';
import { SenderIdSimilarAccountListItem } from '../../../interfaces/sender-id-similar-account-list-item.interface';
import { StatusDirective } from '../../../directives/status-color.directive';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

export interface SimilarOrganisationSidoDialogData {
  senderId: number;
  senderIdText: string;
}

@Component({
  selector: 'si-similar-organisation-sido-dialog',
  standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatTableModule, CommonModule, StatusDirective, SpinnerModule, MatIconModule, RouterLink],
  templateUrl: './similar-organisation-sido-dialog.component.html',
  styleUrls: ['./similar-organisation-sido-dialog.component.scss'],
})
export class SimilarOrganisationSidoDialogComponent {
  public readonly columns = ['senderIDText', 'orgName', 'status'];

  private readonly maskService = inject(FullPageMaskService);
  private readonly senderIdService = inject(SenderIdService);
  private readonly dialogRef = inject(MatDialogRef<SimilarOrganisationSidoDialogComponent>);
  public data = inject<SimilarOrganisationSidoDialogData>(MAT_DIALOG_DATA);
  public isFetching = true;

  public dataSource$ = defer(() => {
    this.maskService.showLoading();
    return this.senderIdService.getSenderIdSimilarAccountList$(this.data.senderId);
  }).pipe(
    map((data) => {
      return new MatTableDataSource<SenderIdSimilarAccountListItem>(data);
    }),
    finalize(() => {
      this.maskService.hideLoading();
      this.isFetching = false;
    }),
    catchError(() => {
      return of(new MatTableDataSource<SenderIdSimilarAccountListItem>([]));
    })
  );

  handleClose() {
    this.dialogRef.close();
  }
}
